<template>
  <div class="pos-role">
    <div class="info-title">
      <div class="title">{{$t('pos_roles.role')}}</div>
      <div class="subtitle">{{$t('pos_roles.single_subtitle')}}</div>
    </div>

    <div class="subtitle-2">{{$t('pos_roles.role_information')}}</div>
    <div class="columns">
      <div class="column">
        <div class="group">
          <label>{{$t('name')}}</label>
          <input type="text" v-model="value.name">
        </div>
      </div>
      <div class="column"></div>
    </div>

    <div class="separator"></div>
    <div class="subtitle-2">{{$t('pos_roles.permissions')}}</div>
    <div class="category-container">
      <div v-for="(pbc,i) of permissionsByCategory" :key="`pbc_${i}`">
        <PanelCard size="small">
          <template #header>
            <div class="card-header">
              <div class="title">{{$to(pbc.category.name)}}</div>
              <div></div>
            </div>
          </template>
          <template #default>
            <ToggleSwitch v-for="p of pbc.permissions" v-model="localWhitelistFlags[p.id]" :key="`perm_${p.id}`" text-after>
              {{$to(p.name)}}
            </ToggleSwitch>
          </template>
        </PanelCard>
      </div>
    </div>


    <!--<div class="separator"></div>
    <div class="subtitle-2">{{$t('pos_roles.functions')}}</div>
    <div class="group" v-for="f of functions" :key="`fn_${f.id}`">
      <input type="checkbox" :id="`fn_${f.id}`" :value="f.id" v-model="role.functions">
      <label :for="`fn_${f.id}`">{{$to(f.name)}}</label>
    </div>-->

  </div>
</template>

<script>
import Vue from "vue";
import ToggleSwitch from "@/components/tools/ToggleSwitch";
import PanelCard from "@/components/PanelCard";

export default {
  name: "PosRole",
  components: {ToggleSwitch, PanelCard},

  data() {
    return {
      localWhitelistFlags: {},
      localBlacklistFlags: {}
    }
  },

  props: {
    value: Object,
    functions: Array,
    permissionData: {
      type: Object,
      required: true,
      validator: o => !!o.permissions && !!o.categories
    },
  },

  computed: {
    categories() {
      return this.permissionData.categories;
    },
    permissions() {
      return this.permissionData.permissions;
    },
    permissionsByCategory() {
      let mapByCategory = new Map();
      for (let c of this.categories) {
        mapByCategory.set(c.id, []);
      }
      for (let p of this.permissions) {
        if (mapByCategory.has(p.category)) {
          mapByCategory.get(p.category).push(p)
        }
      }
      /* return List<{category: Category, permissions: List<Permission>}> */
      return this.categories
          .map(category => ({category, permissions: mapByCategory.get(category.id)}))
    }
  },

  watch: {
    value: {
      immediate: true,
      handler: function () { this.updateLocalPermissionFlags()  }
    },
    permissions: {
      immediate: true,
      handler: function () { this.updateLocalPermissionFlags() }
    },
    localWhitelistFlags: {
      deep: true,
      handler: function(e) {
        if (!this.value.whitelist) {
          Vue.set(this.value, 'whitelist', {});
        }
        this.updatePermissionsOfData(e, this.value.whitelist)
      }
    },
    localBlacklistFlags: {
      deep: true,
      handler: function(e) {
        if (!this.value.blacklist) {
          Vue.set(this.value, 'blacklist', {});
        }
        this.updatePermissionsOfData(e, this.value.blacklist)
      }
    }
  },

  methods: {
    updatePermissionsOfData(localFlags, dataFlags) {
      for (let [k,v] of Object.entries(localFlags)) {
        if (v && !dataFlags[k]) {
          Vue.set(dataFlags, k, v);
        } else if (!v && dataFlags[k]) {
          Vue.delete(dataFlags, k)
        }
      }
    },

    updateLocalPermissionFlags() {
      if (this.permissions) {
        this.localWhitelistFlags = {};
        for (let p of this.permissions) {
          Vue.set(this.localWhitelistFlags, p.id, false);
        }
      }
      if (this.value && this.value.whitelist) {
        for (let [k,v] of Object.entries(this.value.whitelist)) {
          if (typeof this.localWhitelistFlags[k] === 'boolean') {
            this.localWhitelistFlags[k] = !!v;
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .separator {
    width: 100%;
    height: 1px;
    border-top: 1px dashed #d9d9d9;
    margin: 20px 0 30px 0;
  }

  .info-title {
    .title {
      font-weight: bold;
    }
    .subtitle {
      font-weight: normal;
      font-size: 14px;
      margin-bottom: 30px;
      color: #808080;
    }
  }

  .category-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 10px;
    row-gap: 10px;

    .card-header {
      display: flex;
      justify-content: space-between;
    }
    .title {
      color: var(--secondary-color);
      font-weight: bolder;
    }
  }
</style>